module.exports = __webpack_public_path__ + "static/img/back.b8c4c33c.svg";